import * as types from './mutation-types';

export default {
  [types.SET_CENQ_COLLECTION](state, payload) {
    state.cenqCollection = payload;
  },
};
